// Centralized data-testid constants
export const TID = {
  // Promo / Header
  promoBar: 'promo-bar',
  promoBookBtn: 'promo-book-btn',
  navLogo: 'nav-logo',
  navLink: (k) => `nav-link-${k}`,
  navMobileToggle: 'nav-mobile-toggle',
  headerBookBtn: 'header-book-btn',

  // Hero
  heroBookBtn: 'hero-book-btn',
  heroPricingBtn: 'hero-pricing-btn',

  // Treatments
  treatmentCard: (id) => `treatment-card-${id}`,
  treatmentBookBtn: (id) => `treatment-book-btn-${id}`,

  // Pricing
  pricingRow: (i) => `pricing-row-${i}`,
  pricingBookBtn: 'pricing-book-btn',

  // Team
  teamCard: (id) => `team-card-${id}`,
  teamBookBtn: (id) => `team-book-btn-${id}`,

  // FAQ
  faqItem: (i) => `faq-item-${i}`,

  // Inquiry form
  inquiryForm: 'inquiry-form',
  inquiryName: 'inquiry-name',
  inquiryEmail: 'inquiry-email',
  inquiryPhone: 'inquiry-phone',
  inquiryService: 'inquiry-service',
  inquiryMessage: 'inquiry-message',
  inquirySubmit: 'inquiry-submit',
  inquirySuccess: 'inquiry-success',
  inquiryError: 'inquiry-error',

  // Footer
  footerBookBtn: 'footer-book-btn',
  footerInstagram: 'footer-instagram',
  footerMaps: 'footer-maps',
};
